module.exports = "/_next/static/images/269279a4161e50146afef170a857df62-heart.svg.webp";